<div
    class="malou-box-shadow fixed bottom-0 right-16 z-10 rounded-t-lg bg-white p-4"
    [@appearDisappearFromBottomAnimation]="
        isOpen() ? appearDisappearFromBottomAnimation.openState : appearDisappearFromBottomAnimation.closedState
    "
    [hidden]="isHidden()"
    (@appearDisappearFromBottomAnimation.done)="onAnimationDone($event)">
    <div class="relative">
        <mat-icon
            class="malou-color-primary absolute right-0 top-0 z-10 !h-[16px] !w-[16px] cursor-pointer"
            [svgIcon]="SvgIcon.CROSS"
            (click)="onCrossClick()"></mat-icon>
        <div class="pr-6">
            <ng-template #dynamicTemplate></ng-template>
        </div>
    </div>
</div>
